<template>
  <v-dialog v-model="dialog" class="reject-dialog" :max-width="isMobile ? '332px' : '558px'" @click:outside="clearFields">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <mf-button id="industry_proposal_reject_campaign_button" label="Rejeitar campanha" color="vermelho-d20" text />
      </div>
    </template>
    <v-progress-linear v-if="loading" class="py-1" rounded indeterminate color="vermelho-d20" />
    <v-card class="reject-card">
      <span class="reject-title">Sua opinião é importante!</span>
      <div class="reject-content">
        <span class="cinza-d10-text">O que te motivou a tomar essa decisão?</span>

        <v-radio-group v-model="reason" class="mt-1 ml-1">
          <v-radio v-for="(options, index) in rejectOptions" id="industry_reject_campaign_select_reason" :key="index" :value="options.value">
            <template #label>
              <span class="cinza-0-text">{{ options.text }}</span>
            </template>
          </v-radio>
        </v-radio-group>

        <div class="mb-2">
          <span class="cinza-d10-text">Deixe mais detalhes sobre a decisão para que possamos melhorar: </span>
        </div>

        <v-textarea
          v-model="details"
          placeholder="Motivos do rejeite"
          :rows="isMobile ? 1 : 2"
          outlined
          :error="detailsTextError.length > 0"
          :error-messages="detailsTextError"
          @keydown.enter="submit"
          @input="$v.details.$touch()"
          @blur="$v.details.$touch()"
        />

        <div class="reject-buttons">
          <mf-button id="industry_reject_campaign_cancel_rejection" label="Cancelar" color="cinza-d20" text :disabled="loading" @click="close" />
          <mf-button
            id="industry_reject_campaign_confirm_rejection"
            label="Rejeitar campanha"
            color="vermelho-d20"
            :disabled="isPrimaryButtonDisabled"
            @click="submit"
          />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators'
import { notOnlySpace } from '@/helpers/validators.js'
import { MUTATION_REJECT_OFFER } from '@/modules/industria/ofertas-trade/graphql'

export default {
  name: 'RejectOfferDialog',
  props: {
    offerScheduleId: {
      type: String,
      required: true,
    },
    isProcessing: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    dialog: false,
    reason: 0,
    details: '',
  }),
  computed: {
    detailsTextError() {
      const errors = []
      if (!this.$v.details.$dirty) return errors
      !this.$v.details.required && errors.push('Preenchimento obrigatório.')
      !this.$v.details.notOnlySpace && errors.push('Este campo não pode conter somente espaços.')
      return errors
    },
    isPrimaryButtonDisabled() {
      return !this.reason || this.loading || this.isProcessing
    },
    rejectOptions() {
      return [
        {
          value: 1,
          text: 'Não tenho os produtos em estoque',
        },
        {
          value: 2,
          text: 'A campanha não gera vantagem competitiva para meu negócio',
        },
        {
          value: 3,
          text: 'Preferência por outras marcas/produtos',
        },
        {
          value: 4,
          text: 'Dificuldade com reembolso',
        },
        {
          value: 5,
          text: 'Dificuldades técnicas',
        },
        {
          value: 6,
          text: 'Condições comerciais da campanha não são atrativas. (Preço)',
        },
        {
          value: 7,
          text: 'Outros',
        },
      ]
    },
  },
  methods: {
    invalidInput() {
      this.$v.$touch()
      return this.$v.$invalid
    },
    async submit() {
      if (this.invalidInput()) return

      this.loading = true
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_REJECT_OFFER,
          variables: {
            input: {
              _id: this.offerScheduleId,
              reason: this.rejectOptions[this.reason - 1].text,
              details: this.details,
            },
          },
        })
        this.close()
        this.$router.push({ name: 'ofertas-trade-propostas' })
      } catch (err) {
        this.$snackbar({ message: 'Erro ao rejeitar campanha.', snackbarColor: 'error' })
      } finally {
        this.loading = false
      }
    },
    close() {
      this.dialog = false
      this.clearFields()
    },
    clearFields() {
      this.reason = 0
      this.details = ''
      this.$v.$reset()
    },
  },
  validations: {
    details: {
      required: requiredIf(function () {
        return this.reason === 7
      }),
      notOnlySpace,
    },
  },
}
</script>

<style lang="scss" scoped>
.reject-dialog {
  height: 482px;

  @media screen and (max-width: $xs-breakpoint) {
    height: 472px;
  }
}

.reject-card {
  padding: 20px 18px;

  .reject-title {
    font-size: 22px;
    font-weight: bold;
    color: $cinza-d10;

    @media screen and (max-width: $xs-breakpoint) {
      font-size: 20px;
    }
  }

  .reject-content {
    margin-top: 20px;
    font-size: 14px;

    .cinza-d10-text {
      color: $cinza-d10;
    }

    .cinza-0-text {
      font-size: 14px;
      color: $cinza-0;
    }

    .reject-buttons {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      gap: 16px;
    }

    ::v-deep .v-input {
      font-size: 14px;
    }
  }
}

::v-deep .v-dialog {
  border: 1px solid $vermelho-d20;
  border-radius: 8px;
  box-shadow: 0px 2px 20px 0px #0000002f;
}
</style>
